import { PATH_LOGIN } from '../navigation/navigation.module';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class MesaGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (localStorage.getItem('token')) {
      if (localStorage.getItem('isMesaDeNegocio') === 'True') {
        return true;
      } else {
        return false;
      }
    } else {
      this.router.navigate([PATH_LOGIN], { queryParams: { returnUrl: state.url }});
      return false;
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/guards/mesa-guard.ts